/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Compose_DescriptionInputs */



/**
* | output |
* | --- |
* | "Tell us what happened or what you would like to see. We reply by email." |
*
* @param {Support_Compose_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_compose_description = /** @type {((inputs?: Support_Compose_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Compose_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreib uns, was passiert ist oder was du dir wünschst. Wir antworten per E-Mail.")
	return /** @type {LocalizedString} */ ("Tell us what happened or what you would like to see. We reply by email.")
});